import { render, staticRenderFns } from "./guanYuContent.vue?vue&type=template&id=b5b020c2&scoped=true"
import script from "./guanYuContent.vue?vue&type=script&lang=js"
export * from "./guanYuContent.vue?vue&type=script&lang=js"
import style0 from "./guanYuContent.vue?vue&type=style&index=0&id=b5b020c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b020c2",
  null
  
)

export default component.exports